export class InternalServerError extends Error {
    readonly status: number;
    constructor(message: string, public uuid: string) {
        super(message);
        this.status = 500;
        this.name = 'internal server error';
    }
}
